import { InputSwitch } from 'primereact/inputswitch';
import React, {useEffect, useRef} from 'react';
import { customerAddressCreate } from '../../../services/CustomerInfo/EditCustomer';

const EditCustomerAddressChange = ({
  activeAddressStatus,
  setActiveAddressStatus,
  itemId,
  addressDetail,
  storeId,
  editCustomerData,
  sendDataToEditCustomer
}) => {
   
 

  const handlePress = async () => {
    // Update the specific field in editCustomerData
    let CustomerID = editCustomerData.id;
    let updatedData = {...addressDetail};
    updatedData.default = true;
    // Add more conditions for other fields
    try {
      const response = await  customerAddressCreate(
        CustomerID,
        storeId,
        updatedData,
      );
      if (!response.data.error) {
        const Res = response.data;
        sendDataToEditCustomer({
          success: true,
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
    setActiveAddressStatus(itemId);
  };

  return (
    <div
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 10,
        marginLeft: 5,
      }}>
      <div
        style={{
          flexDirection: 'row',
          position: 'relative',
          height:
              10,
          borderRadius: 30,
          elevation: 2,
          backgroundColor: '#efebf0',
          width: '100%',
        }}>
           <InputSwitch checked={activeAddressStatus} onChange={handlePress} />
        
      </div>
    </div>
  );
};
export default EditCustomerAddressChange;
